import React, { useContext } from 'react';
import { PortalContext } from '../../context/PortalContext';


export const usePortalShowEAPfilter = () => {
  const { portalData } = useContext(PortalContext);
  const portalShowEAPfilter = portalData?.portalConfig?.showEapFilter;
  return portalShowEAPfilter;
};